import React, {PureComponent, useState, useEffect} from "react";
import {
  Grid,
  Box,
  Typography,
  IconButton,
  Tooltip,
  Button,
} from "@mui/material";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer ,Legend,Tooltip as Tp} from 'recharts';
import ModalLyt from "../../../components/Layouts/ModalLyt/ModalLyt";
import BAUDetails from "../LComponents/BAUDetails/BAUDetails";
import {
    useGetAllBAUsByTeamId,
} from "../../Meeting/Hooks/index";
import { Star } from "@mui/icons-material";

import {
  useGetBAUMeetingHistory,
  useDisLikeMeeting,
  useLikeMeeting,
} from "../Hooks/index";
import {
  ObjectiveSelectedFace,
  bAUSelectedFace,
  krSelectedFace,
} from "../Interfaces/interfaces";
import DyDataGrid from "../../../components/GlobalComponents/DyGriid/DyGriid";
import { useSelector } from "react-redux";
import { EmptyDataIcon } from "../StataicData/index";
import TeamsNavigations from "../LComponents/TeamsNavigation/TeamsNavigations";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import DYToastMessage from "../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import { changeTreeViewStateR } from "../../Meeting/MeetingsSlice/MeetingsSlice";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@mui/material";
import LyBackdrop from "../../../components/Layouts/BackDrop/BackDrop";
import "../../CompanyManagment/Copmonents/Like/Like.css";
import { NewUseStore } from "../../../Store/newUseStore";
import { CreateBAUeval } from "../LComponents/Forms/CreateBAUeval/CreateBAUeval";
import BAUHistoryModalContent from "../LComponents/BAUHistoryModalContent/BAUHistoryModalContent";
import CommentModal from "../../TenantDash/LComponents/AllTenantDash/AnotherComponent ";
import { GridValueFormatterParams } from '@mui/x-data-grid';
import { CreateAttachmentBAU } from "../LComponents/Forms/CreateAttachmentBAU/CreateAttachmentBAU";
import AttachmentIcon from '@mui/icons-material/Attachment';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import KrActions from "../LComponents/KrActions/KrActions";
const BAUs: React.FC = () => {
  const dispatch = useDispatch();
  const treeView = useSelector(
    (state: any) => state.meetings.treeViewState?.treeView
  );
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه
  const priodId: any = useSelector((state: any) => state.meetings.priodId);
  const meetingId: any = useSelector((state: any) => state.meetings.meetingId);
  const [objectivies, setObjectivies] = useState([]);
  const nodeId = NewUseStore((state) => state.newCompanyId);
  const [objectiveSelectedData, setObjectiveSelectedData] = useState<any>(null);
  const [objectiveManiInfo, setObjectiveMainInfo] =
    useState<ObjectiveSelectedFace | null>(null);
  const [SuccessState, setSuccessState] = useState<boolean>(true);
  const [keyR, setKeyR] = useState<any>([]);

  const getObjectiveSuccess = (data: any) => {
    if (data && data.length > 0) {
      setObjectivies(data);
      const selectedRow = objectiveSelectedData
        ? (data.find((item: any) => item.id === objectiveSelectedData.id) ||
          data[0])
        : data[0];
      setRowSelectedData(selectedRow);
      let { name, id } = selectedRow;
      let ObjSelected = {
        name: name,
        id: id,
      };
      
      setObjectiveMainInfo(ObjSelected);
      let keyrs = (selectedRow as any).keyResultCheckingMeetingQueryResultDto
        ? (selectedRow as any).keyResultCheckingMeetingQueryResultDto
        : [];
      setKeyR(keyrs);
      setObjSelectionModel((selectedRow as any).id);
    }
    setSuccessState(false);
  };

  const toPersianDigits = (num : any) => {
    return num.toString().replace(/\d/g, (d:any) => '۰۱۲۳۴۵۶۷۸۹'[d]);
  };

  const getObjectiveError = () => {};

  const {
    data,
    isError: getObjectiveErrorFlag,
    isFetched: getObjectiveAgainFetched,
    isLoading: getObjLoading,
    refetch: callAgain,
  } = useGetAllBAUsByTeamId( //اصلی
    getObjectiveSuccess,
    getObjectiveError,
    nodeId,
    priodId,
    meetingId
  );
  const resizeHandleStyle: React.CSSProperties = {
    width: '100%',  // عرض دستگیره به اندازه کافی بزرگ باشد
    height: '100%',
    cursor: 'ew-resize',
    position: 'absolute',
    right: 0,  // دستگیره در انتهای ستون قرار بگیرد
    top: 0,
    bottom: 0,
    zIndex: 10,  // اطمینان از اینکه دستگیره بالای سایر اجزا باشد
        // backgroundColor: '#ccc', // رنگ پس‌زمینه برای دستگیره

  };

  //
  const companyNode: any = useSelector(
    (state: any) => state.meetings.companyList
  );
  const KRinitialStatee = useSelector(
    (state: any) => state.loign.kRinitialState
  );
  const ObjctivieInitialState = useSelector(
    (state: any) => state.loign.ObjctivieInitialState
  );

  const objUpdated = useSelector((state: any) => state.meetings.objUpdated);
  const teamInfo = useSelector((state: any) => state.meetings.teamInfo);
  const [showModal, setShowModal] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [krRowData, setKrRowData] = useState(null);
  const [showToolbarModal, setShowToolbarModal] = useState<Boolean | null>(
    false
  );
  const [showAddEvalModal, setShowAddEvalModal] = useState<Boolean>(false);
  const [showAttachment, setShowAttachment] = useState(false);
  const [ShowActionsModal, setShowActionsModal] = useState<Boolean>(false);
  const [ShowActionsModal1, setShowActionsModal1] = useState<Boolean>(false);
  const { mutate: likeMeeting, data: likeData } = useDisLikeMeeting();
  const { mutate: disLikeMeeting, data: disLikeData } = useLikeMeeting();
  const tenantId = useSelector((state: any) => state.meetings.profileTenantId);
  const [rowSelectedData, setRowSelectedData] = useState<any>(null);
  const [krMainInfo, setKrMainInfo] = useState<krSelectedFace | null>(null);
  const [showToastMessage, setShowToastMessage] = useState<any>(false);
  const [addEvalAsyncData, setAddEvalAsyncData] = useState<any>(null);
  const [opacity, setOpacity] = React.useState({
    uv: 1,
    pv: 1,
  });

  const handleMouseEnter = (o:any) => {
    const { dataKey } = o;

    setOpacity((op) => ({ ...op, [dataKey]: 0.5 }));
  };

  const handleMouseLeave = (o:any) => {
    const { dataKey } = o;

    setOpacity((op) => ({ ...op, [dataKey]: 1 }));
  };

  const [objectivee, setObjectivee] = useState<any>(
    objectivies?.length > 4 ? "fb7cc4ea-7162-4916-9aa8-834b14308e10" : null
  );
  
  
  useEffect(() => {
    if (!getObjectiveAgainFetched) {
      setObjectivies([]);
      setKeyR([]);
      setObjectiveMainInfo(null);
    }
  }, [getObjectiveAgainFetched]);

  useEffect(() => {
    if (addEvalAsyncData) {
      callAgain();
      setSuccessState(true);
    }
  }, [addEvalAsyncData]);

  const [objcSelectionModel, setObjSelectionModel] = useState<string | any>(
    localStorage.getItem("objcSelectionModel")
  );
  const [krSelectionModel, setKrSelectionModel] = useState<string | any>(
    localStorage.getItem("krSelectionModel")
  );

  const headerCellStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)', // سایه برای برجسته شدن ستون
  };

  const [getCustomerBody, setGetCustomerBody] = useState<any>({
    pageSize: 50000,
    page: 1,
    searchTerm: "",
  });
  const [krId, setKrId] = useState(null);
  const {
    data: KrHistoryData,
    isLoading: KRHLoading,
    isError: KRHError,
    isFetched: KRHFetched,
  } = useGetBAUMeetingHistory(krId, priodId, meetingId);

  useEffect(() => {
    if (objectiveSelectedData) {
      let { name, id , currentValue ,responsibleName,upperLimit,lowerLimit,startValue,source,description} = objectiveSelectedData;
      let ObjSelected = {
        name: name,
        id: id,
        currentValue:currentValue,
        responsibleName: responsibleName,
        upperLimit:upperLimit,
        lowerLimit:lowerLimit,
        startValue:startValue,
        description:description,
        source:source
      };
      setObjectiveMainInfo(ObjSelected);
    }
  }, [objectiveSelectedData]);

  useEffect(() => {
    localStorage.setItem("krSelectionModel", krSelectionModel);
  }, [krSelectionModel]);

  useEffect(() => {
    localStorage.setItem("objcSelectionModel", objcSelectionModel);
  }, [objcSelectionModel]);

  useEffect(() => {
    const krSelectionModel = localStorage.getItem("krSelectionModel");
    if (krSelectionModel) {
      setKrSelectionModel(krSelectionModel);
    }
  }, [addEvalAsyncData]);

  useEffect(() => {
    if (rowSelectedData) {
      let {
        name,
        id,
        responsibleName,
        startDate,
        startValue,
        threeTenthsValue,
        sevenTenthsValue,
        oneValue,
        currentValue,
        problems,
        predict,
        lowerLimit,
        currentStateValue,
        description,
        score,
        attachment,
        upperLimit,
        revenue,
        revenueTwo,
        okR_KeyResultType,
      } = rowSelectedData;
      let krSelected: bAUSelectedFace = {
        name: name,
        id: id,
        responsibleName: responsibleName,
        startDate: startDate,
        startValue: startValue,
        threeTenthsValue: threeTenthsValue,
        sevenTenthsValue: sevenTenthsValue,
        oneValue: oneValue,
        currentValue: currentValue,
        problems: problems,
        attachment: attachment,
        nextState: predict,
        currentState: currentStateValue,
        description: description,
        score: score,
        revenue: revenue,
        lowerLimit:lowerLimit,
        upperLimit: upperLimit,
        revenueTwo: revenueTwo,
        okR_KeyResultType: okR_KeyResultType,
      };
      setKrMainInfo(krSelected);
    }
  }, [rowSelectedData]);

  useEffect(() => {
    if (objectiveSelectedData) {
      let keyrs = (objectiveSelectedData as any).keyResultCheckingMeetingQueryResultDto || [];
      setKeyR(keyrs);
    }
  }, [objectiveSelectedData]);

  const [likec, setLikeCount] = useState<number>(25);
  const [activeBtn, setActiveBtn] = useState<string>("none");
  const initialLikeMeeting = () => {
    let deleteBody = {
      tenantId: tenantId,
      meetingId: meetingId,
    };
    likeMeeting(deleteBody);
  };
  class CustomizedLabel extends PureComponent {
    render() {
      const { x, y, stroke, value } : any= this.props;
  
      return (
        <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="middle">
          {value}
        </text>
      );
    }
  }
  
  const initialDisLikeMeeting = () => {
    let deleteBody = {
      tenantId: tenantId,
      meetingId: meetingId,
    };
    disLikeMeeting(deleteBody);
  };

  const handleReactionClick = (reaction: string): void => {
    if (activeBtn === "none") {
      if (reaction === "like") {
        setLikeCount(likec + 1);
        setActiveBtn("like");
        initialLikeMeeting();
      }
    } else if (activeBtn === reaction) {
      if (reaction === "like") {
        setLikeCount(likec - 1);
        initialDisLikeMeeting();
      }
      setActiveBtn("none");
    } else if (activeBtn !== reaction) {
      if (reaction === "like") {
        setActiveBtn("like");
      }
    }
  };

  const [imgSrc, setImgSrc] = useState<string | null>(null);
  const [showImageSelector, setShowImageSelector] = useState<boolean>(false);
  const handleImageChange = (newImgSrc: string) => {
    setImgSrc(newImgSrc);
    localStorage.setItem('tenantImage', newImgSrc); // Save to localStorage
    setShowImageSelector(false);
  };

  const handleImageSelectorClose = () => {
    setShowImageSelector(false);
  };

  const objectiveColumns: any = [
    // {
    //   field: "rowid",
    //   headerName: "ردیف",
    //   width: 35,
    //   sortable: false,
    //   align: "center",
    //   headerAlign: "center",
    //   renderCell: (params: any) =>
    //     params.api.getAllRowIds().indexOf(params.id) + 1,
    // },
    {
      field: "combinedField",
      headerName: "",
      align: "center",
      headerAlign: "center",
      sortable: false,
      // minWidth: 160,
      width: 100,
      // renderHeader: (params:any) => (
      //   // <div style={headerCellStyle}>
      //   //   {params.colDef.headerName}
      //   //   <div
      //   //     style={resizeHandleStyle}
      //   //     onMouseDown={(e) => handleMouseDown(e, 'combinedField')}
      //   //   />
      //   // </div>
      // ),
      renderCell: ({ row }: any) => {
        const { commentCount, id, name, attachment } = row;
    
        // const handleDoubleClick = () => {
        //   setKrId(id);
        //   setShowAddEvalModal(true);
        // };
    
        return (
          <Box display="flex" justifyContent="space-between" alignItems="center" style={{ width: "100%" }}>
            
            {/* آیکون ضمیمه */}
            <Box sx={{ width: "40px", textAlign: "center" }}>
            
              {attachment && (
                <Tooltip title="ضمیمه موجود است">
                  <Button
                  sx={{ fontSize: "10px" }}
                  variant="text"
                  onClick={() => {
                    setShowAttachment((prev: any) => !prev);
                    setKrId(id);
                    setKrMainInfo(row);
                  }}
                  startIcon={<AttachmentIcon />}
                >
                  {/* ضمیمه */}
                </Button>
                  {/* <AttachmentIcon
                   
                   sx={{ fontSize: "16px", color: "blue" }} 
                   /> */}
                </Tooltip>
              )}
            </Box>
    
            {/* نظرات */}
            <Box sx={{ width: "40px", textAlign: "center" }}>
              <CommentModal id={id} name={name} meetingId={meetingId} commentCount={commentCount} />
            </Box>
          </Box>
        );
      },
    },
      {
    field: "name",
    align: "left",
    headerName: "شرح",
    headerAlign: "center",
    sortable: false,
    wrap: "wrap",
    minWidth: 350,
    fontsize: "12px !important",
    renderCell: ({ value, row }: { value: any; row: any }) => {
      return (
        <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {row.isStrategic && (
            <Star style={{ color: "#FFD700", fontSize: "20px" }} />
          )}
          {value.length > 40 ? (
              <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                {value}
              </Tooltip>
            ) : (
              <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
            )}
        
        </Box>
      );
    },
  },

    // {
    //   field: "name",  
    //   align: "left",
    //   headerName: "شرح",
    //   headerAlign: "center",
    //   sortable: false,
    //   wrap: "wrap",
    //   minWidth: 350,
    //   fontsize: "12px !important",
    //   renderCell: ({ value }: any) => {
    //     return (
    //       <Box>
            // {value.length > 40 ? (
            //   <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
            //     {value}
            //   </Tooltip>
            // ) : (
            //   <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
            // )}
    //       </Box>
    //     );
    //   },
    // },
    

    {
      field: "measurementUnit",
      headerName: "معیار سنجش",
      align: "center",
      headerAlign: "center",
      sortable: false,
      minWidth: 60,
      hideable: true,
      hide: true,
      fontsize: "14px",
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            //style={{ width: "100%", cursor: "pointer" }} // تنظیم عرض و نشانگر موس
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {value.length > 40 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  {value}
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
              )}
            </Box>
          </div>
        );
      },
    },
    {
      field: "reportingPeriod",
      headerName: "منطق گزارش دهی",
      align: "center",
      headerAlign: "center",
      sortable: false,
      minWidth: 60,
      hideable: true,
      hide: true,
      fontsize: "14px",
      renderCell: ({ value, row }: any) => {
        return (
          <div
            onDoubleClick={() => {
              if (row && row.id) {
                setKrId(row.id);
                setShowAddEvalModal(true); // باز کردن مدال
              }
            }}
            //style={{ width: "100%", cursor: "pointer" }} // تنظیم عرض و نشانگر موس
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {value.length > 40 ? (
                <Tooltip sx={{ fontSize: "1.5rem !important" }} title={value}>
                  {value}
                </Tooltip>
              ) : (
                <Typography sx={{ fontSize: "12px" }}>{value}</Typography>
              )}
            </Box>
          </div>
        );
      },
    },
    {
      field: "responsibleName",
      headerName: "مسئول",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 170,
    },
    // {
    //     field: "startValue",
    //     headerName: "شروع",
    //     align: "center",
    //     sortable: false,
    //     headerAlign: "center",
    //     width: 80,
    //     valueFormatter: (params: GridValueFormatterParams) => {
    //       const value = params.value as number; // گرفتن مقدار سلول
    //       // بررسی اینکه آیا مقدار منفی است یا خیر
    //       return value < 0 ? `${Math.abs(value)}-` : `${value}`; // نمایش عدد منفی در انتها

    //   }
    // },
    // {
    //     field: "lowerLimit",
    //     headerName: "حد پایین",
    //     align: "center",
    //     sortable: false,
    //     headerAlign: "center",
    //     width: 80,
    // },
    // {
    //     field: "upperLimit",
    //     headerName: "حد بالا",
    //     align: "center",
    //     sortable: false,
    //     headerAlign: "center",
    //     width: 80,
    // },
    {
      field: "startValue",
      headerName: "شروع",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 80,
      valueFormatter: (params: GridValueFormatterParams) => {
          const value = params.value as number;
          return value < 0 ? `${Math.abs(value)}-` : `${value}`;
      }
  },
  {
      field: "lowerLimit",
      headerName: "حد پایین",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 80,
      valueFormatter: (params: GridValueFormatterParams) => {
          const value = params.value as number;
          return value < 0 ? `${Math.abs(value)}-` : `${value}`;
      }
  },
  {
      field: "upperLimit",
      headerName: "حد بالا",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 80,
      valueFormatter: (params: GridValueFormatterParams) => {
          const value = params.value as number;
          return value < 0 ? `${Math.abs(value)}-` : `${value}`;
      }
  },
  
    // {
    //     field: "currentValue",
    //     headerName: "مقدار جدید",
    //     align: "center",
    //     sortable: false,
    //     headerAlign: "center",
    //     width: 80,
    //     renderCell: (par: any) => {
    //       let lastValue: any = par?.row?.currentValueO;
    //       let lowerLimit: any = par?.row?.lowerLimitO;
    //       let upperLimit: any = par?.row?.upperLimitO;
    //       return (
    //         lastValue !== null ?
    //         <Box 
    //         bgcolor={lastValue >= lowerLimit && lastValue <= upperLimit ? "#D5f7D4" : '#FFEEE5 '}
    //         sx={{ width: "100%", textAlign: "center" }}>
    //         <Typography
    //         color={lastValue >= lowerLimit && lastValue <= upperLimit ? "#125610" : '#993600 '}
    //         fontSize={"0.8rem"}
    //       >
    //         {lastValue}
    //       </Typography>
    //         </Box>:
    //         <Box>-</Box>
    //       );
    //     },
    // },
    {
      field: "currentValue",
      headerName: "مقدار جدید",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 80,
      renderCell: (par: any) => {
        let lastValue: any = par?.row?.currentValueO;
        let lowerLimit: any = par?.row?.lowerLimitO;
        let upperLimit: any = par?.row?.upperLimitO;
    
        // تبدیل مقادیر منفی به فرمت دلخواه (یعنی 2- به جای -2)
        const formattedValue = lastValue < 0 ? `${Math.abs(lastValue)}-` : lastValue;
    
        return (
          lastValue !== null ?
          <Box 
            bgcolor={lastValue >= lowerLimit && lastValue <= upperLimit ? "#D5f7D4" : '#FFEEE5 '}
            sx={{ width: "100%", textAlign: "center" }}
          >
            <Typography
              color={lastValue >= lowerLimit && lastValue <= upperLimit ? "#125610" : '#993600 '}
              fontSize={"0.8rem"}
            >
              {formattedValue}
            </Typography>
          </Box> :
          <Box>-</Box>
        );
      },
    },    
    {
      field: "status",
      headerName: "وضعیت شاخص",
      align: "center",
      sortable: false,
      headerAlign: "center",
      width: 100,
      renderCell: (par: any) => {
        const lastValue: any = par?.row?.currentValueO;
        const lowerLimit: any = par?.row?.lowerLimitO;
        const upperLimit: any = par?.row?.upperLimitO;
    
        const isWithinLimits =
          lastValue !== null &&
          lastValue >= lowerLimit &&
          lastValue <= upperLimit;
    
        return (
          <Box
            bgcolor={isWithinLimits ? "#D5f7D4" : "#FFEEE5"}
            sx={{
              width: "100%",
              textAlign: "center",
              borderRadius: 2,
              padding: "2px"
            }}
          >
            <Typography
              color={isWithinLimits ? "#125610" : "#993600"}
              fontSize={"0.7rem"}
            >
              {isWithinLimits ? "بین حدود" : "خارج از حدود"}
            </Typography>
          </Box>
        );
      }
    },
    {
      field: "objectivesStateName",
      headerName: "وضعیت",
      sortable: false,
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: ({ value }: any) => {
        return (
          <Box
            m={3}
            borderRadius={2}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            height={"75%"}
            bgcolor={value === "فعال" ? "#D5F7D4" : "#E5F1FF"}
          >
            <Typography fontSize={"0.8rem"} px={8}>
              {value}
            </Typography>
          </Box>
        );
      },
    }
    ,
    { field: 'updateBy',
    align:'center',
    headerName: 'بروزرسانی کننده',
    headerAlign:'center',
    sortable:false,
    hideable: true,
    wrap:'wrap',
     width:110
    }
    ,
    { field: 'upperCount',
    align:'center',
    headerName: 'تعداد ارزیابی های بین حد بالا و پایین',
    headerAlign:'center',
    sortable:false,
    wrap:'wrap',
     width:105
    }
    ,
    { field: 'lowerCount',
    align:'center',
    headerName: 'تعداد ارزیابی های خارج از حد بالا و پایین',
    headerAlign:'center',
    sortable:false,
    wrap:'wrap',
     width:105
    }
    ,
      { field: 'count',
        align:'center',
        headerName: 'تعداد دفعات فاقد ارزیابی',
        headerAlign:'center',
        sortable:false,
        wrap:'wrap',
        width:105
        }
    ,
    // {
    //   field: "comment",
    //   headerName: "نظرات",
    //   align: "center",
    //   headerAlign: "center",
    //   sortable: false,
    //   minWidth: 60,
    //   fontsize: "14px",
    //   renderCell: ( par : any) => {
    //     if(par !== undefined && par !== null){
    //     let idd: string = par?.row?.id;
    //     let namee: string = par?.row?.name;
    //     let commentCount: number = par?.row?.commentCount;
    //     return (
    //       <Box display={"flex"} justifyContent={"end"}>
    //       <CommentModal id={idd} name={namee} meetingId={meetingId} commentCount={commentCount}/>
    //       </Box>
    //   )
    //     }
    //   },
    // },
    // {
    //   field: "commentCount",
    //   headerName: "تعداد نظرات",
    //   align: "center",
    //   headerAlign: "center",
    //   sortable: false,
    //   minWidth: 60,
    //   fontsize: "14px",
    // },
  ];

  const renderContents = () => {
    if (!keyR && !getObjLoading) {
      return (
        <Box
          width={"50%"}
          mx={"auto"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <EmptyDataIcon style={{ width: "80px", height: "80px" }} />
          <Typography mt={2} color={"blue"} textAlign={"center"}>
          </Typography>
        </Box>
      );
    } else {
      return (
        <Grid item xs={12}>
          <Grid container>
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-around"}
            >
              <Box px={3} display={"flex"} flexDirection={"row-reverse"}>
                <Box display={"flex"} flexDirection={"row"}>
                  <Typography fontSize={"13px"} fontWeight={700}>
                    شاخص: {objectivee?.name}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            {!getObjLoading && (
              <div style={{ width: '100%'}}>
                {/* <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={800}
                  height={300}
                  data={keyR}
                  margin={{
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 10,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis 
                    dataKey="meetingDate"
                    tickFormatter={(tick) => toPersianDigits(tick)}  />
                  <YAxis 
                  tickFormatter={(tick) => toPersianDigits(tick)} />
                  <Legend onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
                  <Line 
                    type="monotone" 
                    dataKey="reportUpperLimit" 
                    stroke="#8884d8" 
                    activeDot={{ r: 8 }} 
                    name="حد بالا"  // سفارشی کردن عنوان Legend
                  />
                  <Line 
                    type="monotone" 
                    dataKey="reportNewValue" 
                    stroke="#83339d" 
                    name="مقدار جدید"  // سفارشی کردن عنوان Legend
                  />
                  <Line 
                    type="monotone" 
                    dataKey="reportLowerLimit" 
                    stroke="#82ca9d" 
                    name="حد پایین"  // سفارشی کردن عنوان Legend
                  />
                </LineChart>
              </ResponsiveContainer> */}
              <ResponsiveContainer width="100%" height={250}>
              <LineChart
                width={800}
                height={300}
                data={keyR}
                margin={{
                  top: 20,
                  right: 30,
                  left: 20,
                  bottom: 10,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                  dataKey="meetingDate"
                  tickFormatter={(tick) => toPersianDigits(tick)}  />
                <YAxis 
                tickMargin={40} 
                tickFormatter={(tick) => toPersianDigits(tick)} />
                <Tp 
                 content={<CustomTooltip />}
                />
                <Legend onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} />
                <Line 
                  type="monotone" 
                  dataKey="reportUpperLimit" 
                  stroke="#71116d" 
                  activeDot={{ r: 8 }} 
                  name="حد بالا"  // سفارشی کردن عنوان Legend
                />
                <Line 
                  type="monotone" 
                  dataKey="reportNewValue" 
                  stroke="#044440" 
                  name="مقدار جدید"  // سفارشی کردن عنوان Legend
                />
                <Line 
                  type="monotone" 
                  dataKey="reportLowerLimit" 
                  stroke="#88009d" 
                  name="حد پایین"  // سفارشی کردن عنوان Legend
                />
              </LineChart>
            </ResponsiveContainer>
              </div>
            )}
          </Grid>
        </Grid>
      );
    }
  };

// const CustomTooltip = ({ active, payload, label } : any) => {
//   if (active && payload && payload.length) {
//     return (
//       <div className="custom-tooltip" style={{ backgroundColor: '#00387C', color : '#fff', padding: '10px', border: '4px solid #ccc', fontFamily: 'Yekan, sans-serif' }}>
//         <p className="label">{`تاریخ: ${label}`}</p>
//         <p>{`حد بالا: ${payload[0] !== null && payload[0] !== undefined ? payload[0].value : '-'}`}</p>
//         <p>{`مقدار جدید: ${payload[1] !== null && payload[1] !== undefined ? payload[1].value : '-'}`}</p>
//         <p>{`حد پایین: ${payload[2] !== null && payload[2] !== undefined ? payload[2].value : '-'}`}</p>
//       </div>
//     );
//   }
  
//   return null;
// };
const CustomTooltip = ({ active, payload, label } : any) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip" style={{ backgroundColor: '#00387C', color : '#fff', padding: '10px', border: '4px solid #ccc', fontFamily: 'Yekan, sans-serif' }}>
        <p className="label">{`تاریخ: ${label}`}</p>
        <p>{`حد بالا: ${payload[0] !== null && payload[0] !== undefined ? payload[0].value : '-'}`}</p>
        <p>{`مقدار جدید: ${payload[1] !== null && payload[1] !== undefined ? payload[1].value : '-'}`}</p>
        <p>{`حد پایین: ${payload[2] !== null && payload[2] !== undefined ? payload[2].value : '-'}`}</p>
      </div>
    );
  }
  
  return null;
};


  return (
    <>
      <Grid container sx={{ bgcolor: "#F9F9F9" }} style={{ width: "100%" }}>
        <Grid item xs={treeView ? 12 : 10}>
          <Box py={1} my={2} borderRadius={1} boxShadow={1} bgcolor={"white"}>
            <Grid container>
              <Grid item xs={12} md={3}>
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    fontWeight={600}
                    fontSize={"13px"}
                    variant="button"
                    px={1}
                  >
                    {teamInfo.isCompany ? "نام شرکت:" : "نام تیم:"}
                  </Typography>
                  <Typography fontWeight={600} fontSize={"13px"}>
                    {teamInfo?.name}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={3}>
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography
                    fontWeight={600}
                    fontSize={"13px"}
                    variant="button"
                    px={1}
                  >
                    {teamInfo.isCompany ? "مدیر شرکت:" : "مدیر تیم:"}
                  </Typography>
                  <Typography fontWeight={600} fontSize={"13px"}>
                    {teamInfo?.managerCompanyName}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={3}>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {!treeView && (
          <Grid
            mx={"auto"}
            item
            xs={12}
            sm={1.7}
            display={"flex"}
            alignItems={"center"}
          >
            <Grid container borderRadius={2} boxShadow={1}>
              <Grid item xs={9} my={"auto"}>
                <TeamsNavigations />
              </Grid>
              <Grid item xs={3} py={1}>
                <IconButton
                  size="small"
                  onClick={() => {
                    dispatch(changeTreeViewStateR());
                  }}
                >
                  <AccountTreeIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Box width={"100%"} borderRadius={2} boxShadow={2} bgcolor={"white"}>
          <Grid item xs={12}>
            <Typography
              px={3}
              py={1}
              textAlign={"left"}
              fontSize={"16px"}
              color={"#00387C"}
              fontWeight={800}
            >
              لیست BAU
            </Typography>
            {!getObjLoading && objectivies && objectivies.length > 0 && (
              <DyDataGrid
                initialOnRowClick={setObjectivee}
                data={objectivies}
                columns={objectiveColumns || []}
                hideFooter={true}
                aut
                setRowSelectedData={setObjectiveSelectedData}
                objcSelectionModel={objcSelectionModel}
                setSelectionModel={setObjSelectionModel}
                selectionModel={objcSelectionModel}
                initState={ObjctivieInitialState}
                initialMount={true}
                additionalToolbar={true}
                setShowHistory={setHistoryModal}
                setSpecialId={setKrId}
                setShowInformation={setShowModal}
                setShowAttachment={setShowAttachment}
                setShowAddEvalModal={setShowAddEvalModal}
                setShowActionsModal={setShowActionsModal}
                setShoowCommitmentsModal={setShowActionsModal1}
                drName={"ObjctivieInitialState"}
              />
            )}
          </Grid>
        </Box>

        <Box
          mt={2}
          width={"100%"}
          borderRadius={3}
          boxShadow={2}
          bgcolor={"white"}
        >
          <Grid item xs={12}>
            <Typography
              px={3}
              fontSize={"16px"}
              //py={1}
              textAlign={"left"}
              variant="h6"
              color={"#00387C"}
              fontWeight={800}
            >
               نمودار سابقه ارزیابی های اخیر
            </Typography>
            <Grid container>{renderContents()}</Grid>
          </Grid>
        </Box>
          {showModal && objectivee && (
          <ModalLyt
            title={"اطلاعات شاخص"}
            width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            showModal={Boolean(showModal)}
            setShowModal={setShowModal}
          >
            <BAUDetails
              data={objectivee}
            />
          </ModalLyt>
        )} 

         {historyModal && (
          <ModalLyt
            loadingFlag={KRHLoading}
            title={"تاریخچه شاخص "}
            showModal={Boolean(historyModal)}
            setShowModal={setHistoryModal}
          >
            <BAUHistoryModalContent
              loadingFlag={KRHLoading}
              data={KrHistoryData}
              krDetail={objectiveManiInfo}
              objective={objectivee}
            />
          </ModalLyt>
        )} 
{showAttachment && (
          <ModalLyt
            width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"ضمیمه"}
            showModal={Boolean(showAttachment)}
            setShowModal={setShowAttachment}
          >
              <CreateAttachmentBAU
              cancelo={setShowAddEvalModal}
              objectiveManiInfo={objectiveManiInfo}
              krMainInfo={krMainInfo}
              setChangeImgData={handleImageChange}
              onClose={handleImageSelectorClose}
              objectiveId={objectivee?.id}
              kresultId={krId}
              onsucces={setShowAddEvalModal}
              setShowToastMessage={setShowToastMessage}
              setAddEvalAsyncData={setAddEvalAsyncData}
            />
          </ModalLyt>
        )}
        {showAddEvalModal && (
          <ModalLyt
          width={isMobile ? '350px' : '1300px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"تعیین مقدار برای شاخص"}
            showModal={Boolean(showAddEvalModal)}
            setShowModal={setShowAddEvalModal}
          >
           
            <CreateBAUeval
              cancelo={setShowAddEvalModal}
              objectiveManiInfo={objectiveManiInfo}
              krMainInfo={krMainInfo}
              objectiveId={objectivee?.id}
              kresultId={krId}
              onsucces={setShowAddEvalModal}
              setShowToastMessage={setShowToastMessage}
              setAddEvalAsyncData={setAddEvalAsyncData}
            />
          </ModalLyt>
        )}
        {ShowActionsModal1 && (
          <ModalLyt
            width={isMobile ? '350px' : '1100px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"تعهدات"}
            showModal={Boolean(ShowActionsModal1)}
            setShowModal={setShowActionsModal1}
          >
            <KrActions
              loadingFlag={KRHLoading}
              data={KrHistoryData}
              krDetail={objectivee}
              objective={objectivee}
              isBAU={true}
            />
          </ModalLyt>
        )}

        {showToolbarModal && (
          <ModalLyt
            title={"نتیجه کلی"}
            showModal={Boolean(showToolbarModal)}
            setShowModal={setShowToolbarModal}
          >
          </ModalLyt>
        )}

        {SuccessState && (
          <LyBackdrop
            visible={SuccessState}
          >
            <Box>
              <CircularProgress color="inherit" />
            </Box>
          </LyBackdrop>
        )}

        {showToastMessage && (
          <DYToastMessage
            isSuccess={addEvalAsyncData?.isSuccess}
            message={addEvalAsyncData?.metaData.message}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
      </Grid>
    </>
  );
};

export default BAUs;
